export const twitterKeys = {
    spaces: (id) => ['twitter:spaces', id],
};
